import React from 'react';

const TermAgentNav = ({ model, onNavClick, selectedSection }) => {

    const pendingTypes = import.meta.env.VITE_PENDING_TYPES || '';
    const bobTypes = import.meta.env.VITE_BOB_TYPES || '';

    const navButton = (id, label, condition = true) =>
        condition && (
            <span
                className={`nav-button ${selectedSection === id ? 'active' : ''}`}
                onClick={() => onNavClick(id)}
            >
                {label}
            </span>
        );

    return (
        <div className="nav-buttons-container">
            <div className="nav-buttons d-md-block buttons-wrapper">
                {navButton('agent-statements-container', 'Commission Statements')}
                {navButton('agent-1099-container', '1099s')}
            </div>
        </div>
    );
};

export default TermAgentNav;
